import { isSteamClient } from './steam'

export type PlatformType = 'web' | 'steam'

const navItemsWeb = [
  { id: 'benchmark', key: 'nav.benchmark', type: 'section' as const },
  { id: '/', key: 'nav.game', type: 'route' as const },
  { id: 'vision', key: 'nav.byom', type: 'section' as const },
  { id: '/blogs', key: 'nav.blog', type: 'route' as const },
  { id: '/contact-us', key: 'nav.contact', type: 'route' as const },
]

const navItemsSteam = [
  { id: '/play', key: 'nav.createGame', type: 'route' as const },
  { id: '/play/roles', key: 'nav.steamRoles', type: 'route' as const },
  { id: '/play/rule', key: 'nav.steamRules', type: 'route' as const },
]

interface PlatformConfig {
  type: PlatformType
  navItems: typeof navItemsWeb
  showSignIn: boolean
  showCookieBanner: boolean
  paymentMethod: 'stripe' | 'steam-wallet'
  skipSessionGate: boolean
}

const webConfig: PlatformConfig = {
  type: 'web',
  navItems: navItemsWeb,
  showSignIn: true,
  showCookieBanner: true,
  paymentMethod: 'stripe',
  skipSessionGate: false,
}

const steamConfig: PlatformConfig = {
  type: 'steam',
  navItems: navItemsSteam,
  showSignIn: false,
  showCookieBanner: false,
  paymentMethod: 'steam-wallet',
  skipSessionGate: true,
}

let _cached: PlatformConfig | null = null
function getPlatform(): PlatformConfig {
  if (!_cached) {
    const steam = isSteamClient()
    const steamUA = typeof navigator !== 'undefined' && navigator.userAgent.includes('MentissSteam')
    _cached = (steam || steamUA) ? steamConfig : webConfig
  }
  return _cached
}

export const platform = new Proxy({} as PlatformConfig, {
  get(_target, prop) {
    return getPlatform()[prop as keyof PlatformConfig]
  },
})

export const isSteam = typeof navigator !== 'undefined' && (isSteamClient() || navigator.userAgent.includes('MentissSteam'))
